import D1 from '../../components/ExcerciseTypes/Design/TypeIn';
import DesignUnderLine from '../../components/ExcerciseTypes/Design/DesignUnderLine';

const json = {
  1: {
    unit: 'Unit 9',
    id: 'WB4-V2-U9-P65-E1',
    audio: '',
    video: '',
    component: D1,
    titleImage: '',
    exerciseKey: 'img/FriendsPlus/Page65/E1/Key/answerKey.png',
    question: [
    ],
    questionImage: [
      [
        // Column1
        { url: 'img/FriendsPlus/Page65/E1/1.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page65/E1/2.jpg' },
        { url: 'img/FriendsPlus/Page65/E1/3.jpg', input: true, answer: "fifteen" },
        { url: 'img/FriendsPlus/Page65/E1/4.jpg' },
      ],
      [
        // Column3
        { url: 'img/FriendsPlus/Page65/E1/5.jpg' },
      ],
      [
        // Column4
        { url: 'img/FriendsPlus/Page65/E1/6.jpg' },
        { url: 'img/FriendsPlus/Page65/E1/7.jpg', input: true, answer: "fifteen" },
        { url: 'img/FriendsPlus/Page65/E1/8.jpg' },
        { url: 'img/FriendsPlus/Page65/E1/9.jpg', input: true, answer: "forty-five" },
        { url: 'img/FriendsPlus/Page65/E1/10.jpg' },
      ],
      [
        // Column5
        { url: 'img/FriendsPlus/Page65/E1/11.jpg' },
      ],
      [
        // Column6
        { url: 'img/FriendsPlus/Page65/E1/12.jpg' },
        { url: 'img/FriendsPlus/Page65/E1/13.jpg', input: true, answer: "forty-five" },
        { url: 'img/FriendsPlus/Page65/E1/14.jpg' },
        { url: 'img/FriendsPlus/Page65/E1/15.jpg', input: true, answer: "fifteen" },
        { url: 'img/FriendsPlus/Page65/E1/16.jpg' },
      ],
      [
        // Column7
        { url: 'img/FriendsPlus/Page65/E1/17.jpg' },
      ],


    ]
  },
  2: {
    unit: 'Unit 9',
    id: 'WB4-V2-U9-P65-E2',
    audio: '',
    video: '',
    component: D1,
    hideBtnFooter: true,
    titleImage: '',
    exerciseKey: 'img/FriendsPlus/Page65/E1/Key/answerKey.png',
    question: [
    ],
    questionImage: [
      [
        // Column1
        { url: 'img/FriendsPlus/Page65/E2/1.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page65/E2/2.jpg' },
        { url: 'img/FriendsPlus/Page65/E2/3.jpg', input: true, answer: "" },
        { url: 'img/FriendsPlus/Page65/E2/4.jpg' },
        { url: 'img/FriendsPlus/Page65/E2/5.jpg', input: true, answer: "" },
        { url: 'img/FriendsPlus/Page65/E2/6.jpg' },
        { url: 'img/FriendsPlus/Page65/E2/7.jpg', input: true, answer: "" },
        { url: 'img/FriendsPlus/Page65/E2/8.jpg' },
        { url: 'img/FriendsPlus/Page65/E2/9.jpg', input: true, answer: "" },
        { url: 'img/FriendsPlus/Page65/E2/10.jpg' },
      ],
      [
        // Column3
        { url: 'img/FriendsPlus/Page65/E2/11.jpg' },
        { url: 'img/FriendsPlus/Page65/E2/12.jpg', input: true, answer: "" },
        { url: 'img/FriendsPlus/Page65/E2/13.jpg' },
        { url: 'img/FriendsPlus/Page65/E2/14.jpg', input: true, answer: "" },
        { url: 'img/FriendsPlus/Page65/E2/15.jpg' },
        { url: 'img/FriendsPlus/Page65/E2/16.jpg', input: true, answer: "" },
        { url: 'img/FriendsPlus/Page65/E2/17.jpg' },
        { url: 'img/FriendsPlus/Page65/E2/18.jpg', input: true, answer: "" },
        { url: 'img/FriendsPlus/Page65/E2/19.jpg' },
      ],
      [
        // Column4
        { url: 'img/FriendsPlus/Page65/E2/20.jpg' },
        { url: 'img/FriendsPlus/Page65/E2/21.jpg', input: true, answer: "" },
        { url: 'img/FriendsPlus/Page65/E2/22.jpg' },
        { url: 'img/FriendsPlus/Page65/E2/23.jpg', input: true, answer: "" },
        { url: 'img/FriendsPlus/Page65/E2/24.jpg' },
        { url: 'img/FriendsPlus/Page65/E2/25.jpg', input: true, answer: "" },
        { url: 'img/FriendsPlus/Page65/E2/26.jpg' },
        { url: 'img/FriendsPlus/Page65/E2/27.jpg', input: true, answer: "" },
        { url: 'img/FriendsPlus/Page65/E2/28.jpg' },
      ],
      [
        // Column5
        { url: 'img/FriendsPlus/Page65/E2/29.jpg' },
      ],
      [
        // Column6
        { url: 'img/FriendsPlus/Page65/E2/30.jpg' },
      ],



    ]
  },
  3: {
    unit: 'Unit 9',
    id: 'WB4-V2-U9-P65-E3',
    audio: '',
    video: '',
    component: D1,
    hideBtnFooter: true,
    titleImage: '',
    exerciseKey: 'img/FriendsPlus/Page65/E1/Key/answerKey.png',
    question: [
    ],
    questionImage: [
      [
        // Column1
        { url: 'img/FriendsPlus/Page65/E3/1.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page65/E3/2.jpg' },
      ],
      [
        // Column3
        { url: 'img/FriendsPlus/Page65/E3/3.jpg' },
        { url: 'img/FriendsPlus/Page65/E3/4.jpg', input: true, answer: "" },
        { url: 'img/FriendsPlus/Page65/E3/5.jpg' },
      ],
      [
        // Column4
        { url: 'img/FriendsPlus/Page65/E3/6.jpg' },
        { url: 'img/FriendsPlus/Page65/E3/7.jpg', input: true, answer: "" },
        { url: 'img/FriendsPlus/Page65/E3/8.jpg' },
      ],
      [
        // Column5
        { url: 'img/FriendsPlus/Page65/E3/9.jpg' },
        { url: 'img/FriendsPlus/Page65/E3/10.jpg', input: true, answer: "" },
        { url: 'img/FriendsPlus/Page65/E3/11.jpg' },
      ],
      [
        // Column6
        { url: 'img/FriendsPlus/Page65/E3/12.jpg' },
        { url: 'img/FriendsPlus/Page65/E3/13.jpg', input: true, answer: "" },
        { url: 'img/FriendsPlus/Page65/E3/14.jpg' },
      ],
      [
        // Column7
        { url: 'img/FriendsPlus/Page65/E3/15.jpg' },
        { url: 'img/FriendsPlus/Page65/E3/16.jpg', input: true, answer: "" },
        { url: 'img/FriendsPlus/Page65/E3/17.jpg' },
      ],
      [
        // Column8
        { url: 'img/FriendsPlus/Page65/E3/18.jpg' },
      ],
    ]
  },



}
export default json;